const laminatingOptions = [
    { id: 1, title: 'glossy', price: 0 },
    { id: 2, title: 'matte', price: 0 },
];

export const materials = [
    {
        id: 1,
        title: 'vinyl',
        thumb: `${window.FleetCart.baseUrl}/themes/storefront/public/images/image-editor/materials/vinyl-thumb.png`, //TODO CHANGE
        laminatingOptions: laminatingOptions,
        options: {},
        onAttach: (materialService, material, callback) => {
            if (callback) {
                callback();
            }
        },
    },
    {
        id: 2,
        title: 'holographic',
        thumb: `${window.FleetCart.baseUrl}/themes/storefront/public/images/image-editor/materials/holographic-thumb.jpg`,
        laminatingOptions: laminatingOptions,
        options: {
            replaceBackground: {
                src: `${window.FleetCart.baseUrl}/themes/storefront/public/images/image-editor/materials/holographic.jpg`,
            }
        },
        onAttach: (materialService, material, callback) => {
            materialService.replaceBackground_attach(material, callback);
        },
        onDetach: (materialService, material) => {
            materialService.replaceBackground_detach(material);
        }
    },
    {
        id: 3,
        title: 'prismatic',
        thumb: `${window.FleetCart.baseUrl}/themes/storefront/public/images/image-editor/materials/prismatic-thumb.jpg`,
        laminatingOptions: laminatingOptions,
        options: {
            replaceBackground: {
                src: `${window.FleetCart.baseUrl}/themes/storefront/public/images/image-editor/materials/prismatic.jpg`,
            }
        },
        onAttach: (materialService, material, callback) => {
            materialService.replaceBackground_attach(material, callback);
        },
        onDetach: (materialService, material) => {
            materialService.replaceBackground_detach(material);
        }
    },
    {
        id: 4,
        title: 'gliter',
        thumb: `${window.FleetCart.baseUrl}/themes/storefront/public/images/image-editor/materials/gliter-thumb.png`,
        laminatingOptions: laminatingOptions,
        options: {
            replaceBackground: {
                src: `${window.FleetCart.baseUrl}/themes/storefront/public/images/image-editor/materials/glitter.jpg`,
            }
        },
        onAttach: (materialService, material, callback) => {
            materialService.replaceBackground_attach(material, callback);
        },
        onDetach: (materialService, material) => {
            materialService.replaceBackground_detach(material);
        }
    },
    {
        id: 5,
        title: 'clear_sticker',
        thumb: `${window.FleetCart.baseUrl}/themes/storefront/public/images/image-editor/materials/clear-sticker-thumb.png`, //TODO CHANGE
        laminatingOptions: laminatingOptions,
        options: {},
        onAttach: (materialService, material, callback) => {
            if (callback) {
                callback();
            }
        },
    },
    {
        id: 6,
        title: 'craft_sticker',
        thumb: `${window.FleetCart.baseUrl}/themes/storefront/public/images/image-editor/materials/paper-thumb.jpg`,
        laminatingOptions: laminatingOptions,
        options: {
            replaceBackground: {
                src: `${window.FleetCart.baseUrl}/themes/storefront/public/images/image-editor/materials/paper.jpg`,
            }
        },
        onAttach: (materialService, material, callback) => {
            materialService.replaceBackground_attach(material, callback);
        },
        onDetach: (materialService, material) => {
            materialService.replaceBackground_detach(material);
        }
    },
];

export function getMaterialIdByTitle(title) {
    const material = materials.find(material => material.title === title);
    return material ? material.id : null;
}
